import React, { useState } from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';

import Tokens from 'styles/tokens';
import { ReactComponent as SuccessIcon } from 'images/ic_available_check.svg';
import { ReactComponent as InfoIcon } from 'images/ic_info_blue.svg';
import { ReactComponent as WarningIcon } from 'images/ic_warning.svg';
import { ReactComponent as ErrorIcon } from 'images/ic_error.svg';
import { ReactComponent as JustificationIcon } from 'images/ic_avoma_ai.svg';
import { ReactComponent as LockIcon } from 'images/ic_minimal_lock_purple.svg';
import { twMerge } from 'tailwind-merge';
import ButtonUnstyled from './ButtonUnstyled';

const ICON_MAP = {
  info: InfoIcon,
  error: ErrorIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  justification: JustificationIcon,
  lock: LockIcon
};

const NotificationBanner = ({
  content,
  type = 'info',
  style,
  className,
  collapse = false,
  xs = false,
  sm = false
}) => {
  const containerStyle = styles[type];
  const iconStyle = styles[`${type}Color`];
  const BannerIcon = ICON_MAP[type];
  const [isCollapsed, setIsCollapsed] = useState(true);

  let finalClassName = className;
  if (xs) {
    finalClassName += ' text-xs';
  } else if (sm) {
    finalClassName += ' text-sm';
  }
  return (
    <div
      className={twMerge('flex items-center rounded p-2', finalClassName)}
      style={{
        ...containerStyle,
        ...(type === 'justification' && { padding: 0 }),
        ...style
      }}
    >
      {BannerIcon && <BannerIcon style={{ ...iconStyle, ...styles.icon }} />}
      {collapse ? (
        <div className={isCollapsed ? 'flex' : ''}>
          <span className={`mr-1 ${isCollapsed ? 'line-clamp-1' : ''}`}>
            {content}
          </span>
          <ButtonUnstyled
            className='shrink-0 !font-bold text-[inherit] underline [font:inherit]'
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            view {isCollapsed ? 'more' : 'less'}
          </ButtonUnstyled>
        </div>
      ) : (
        content
      )}
    </div>
  );
};

const styles = {
  error: {
    color: Tokens.colors.redDark,
    backgroundColor: Tokens.colors.redLighter
  },
  warning: {
    color: Tokens.colors.yellowDarker,
    backgroundColor: Tokens.colors.yellowLighter
  },
  info: {
    color: Tokens.colors.blue,
    backgroundColor: Tokens.colors.blueWhiter
  },
  justification: {
    color: Tokens.colors.silver,
    backgroundColor: Tokens.colors.transparent
  },
  success: {
    color: Tokens.colors.greenDark,
    backgroundColor: Tokens.colors.greenLightest
  },
  lock: {
    color: Tokens.colors.purple,
    backgroundColor: Tokens.colors.purpleLighter
  },
  icon: {
    display: 'inline-block',
    position: 'relative',
    minWidth: Tokens.spacing.two,
    width: Tokens.spacing.two,
    height: Tokens.spacing.two,
    margin: '0px 12px 0px 4px'
  },
  errorColor: {
    color: Tokens.colors.red,
    fill: Tokens.colors.red
  },
  warningColor: {
    color: Tokens.colors.yellowDarker,
    fill: Tokens.colors.yellowDarker
  },
  successColor: {
    color: Tokens.colors.green,
    fill: Tokens.colors.green
  },
  justificationColor: {
    color: Tokens.colors.gunmetal,
    fill: Tokens.colors.gunmetal,
    filter: Tokens.filters.silver
  }
};

NotificationBanner.propTypes = {
  content: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  style: stylePropType,
  className: PropTypes.string,
  collapse: PropTypes.bool,
  sm: PropTypes.bool,
  xs: PropTypes.bool
};

export default NotificationBanner;
